<app-usermenu [clickOnProfile]="clickOnProfile" (SideMenuclicked)="onselected($event)"></app-usermenu>
<div class='main-content' [ngClass]="{'marginLeft240 transitionsec':OnSideMenuClick}">
<router-outlet></router-outlet>
</div>

